import logoDark from "@/assets/menuone-logo.png";
import logoLight from "@/assets/menuone-logo-light.png";

export function Logo({ className = "", onDark = false }) {
  return (
    <div className={`flex items-center ${className}`} data-testid="mo-logo">
      <img src={onDark ? logoLight : logoDark} alt="MenuOne" className="h-7 w-auto" />
    </div>
  );
}
